import React, { useState } from 'react';
import { useFormContext } from 'react-hook-form';
import type { BBQSubmission } from '../App';
import Birthday from './Birthday';
import Pflicht from './Pflicht';

interface ContactDataProps {
  onNext: () => void;
  onPrev: () => void;
}

export default function ContactData({ onNext, onPrev }: ContactDataProps) {
  const { register, handleSubmit, watch, setValue } =
    useFormContext<BBQSubmission>();
  const [dateHasFocus, setDateHasFocus] = useState(false);
  const dateHasValue = !!watch('contactData.birthday');

  return (
    <form style={{ minHeight: 400 }} onSubmit={handleSubmit(onNext)}>
      <h2 className={'headline tw:mb-8'}>Wie können wir dich erreichen?</h2>
      <div className={'tw:grid tw:grid-cols-1 tw:sm:grid-cols-2 tw:gap-4 tw:justify-end'}>
        <input
          className={'text-field'}
          required
          {...register('contactData.firstName')}
          autoComplete={'billing given-name'}
          placeholder={'Vorname*'}
        />
        <input
          className={'text-field'}
          required
          {...register('contactData.lastName')}
          autoComplete={'billing family-name'}
          placeholder={'Nachname*'}
        />
        <div>
          {(navigator.maxTouchPoints || (navigator as any).msMaxTouchPoints) ? (
            <p className={'tw:text-sm tw:text-left tw:mb-1 tw:font-semibold'}>Geburtsdatum</p>
          ) : null}
          <input
            className={'text-field tw:appearance-none'}
            type={dateHasFocus || dateHasValue ? 'date' : (navigator.maxTouchPoints || (navigator as any).msMaxTouchPoints ? 'date' : 'text')}
            required
            autoComplete={'billing bday-day'}
            {...register('contactData.birthday', {
              max: new Date().toJSON(),
              onBlur() {
                setDateHasFocus(false);
              },
            })}
            onFocus={() => setDateHasFocus(true)}
            placeholder={'Geburtsdatum*'}
          />
        </div>

        <input
          className={'text-field'}
          required
          {...register('contactData.idNumber')}
          placeholder={'Personalausweisnummer*'}
        />
        <input
          className={'text-field'}
          required
          {...register('contactData.street')}
          autoComplete={'billing address-line1'}
          placeholder={'Straße und Hausnummer*'}
        />
        <input
          className={'text-field'}
          required
          {...register('contactData.zip')}
          autoComplete={'billing postal-code'}
          placeholder={'Postleitzahl*'}
        />
        <input
          className={'text-field'}
          required
          {...register('contactData.city')}
          autoComplete={'billing address-level2'}
          placeholder={'Ort*'}
        />

        <input
          className={'text-field'}
          required
          {...register('contactData.phone', {
            onBlur() {
              if (watch('contactData.phone')?.trim() === '+49') {
                setValue('contactData.phone', '');
              }
            },
          })}
          autoComplete={'billing tel-local'}
          placeholder={'Telefon*'}
          onFocus={() => {
            if (!watch('contactData.phone')) {
              setValue('contactData.phone', '+49 ');
            }
          }}
        />
      </div>
      <input
        className={'text-field tw:w-full tw:mt-4'}
        required
        type={'email'}
        {...register('contactData.email')}
        autoComplete={'billing email'}
        placeholder={'E-Mail*'}
      />
      <label
        className={'tw:flex tw:gap-3 tw:items-center tw:mt-6 tw:text-left'}>
        <input className={'checkbox'} type={'checkbox'} required />
        <span>
          Ich bin mit den <a href={'/'}>Allgemeinen Geschäftsbedingungen</a>{' '}
          einverstanden.
        </span>
      </label>
      <label
        className={'tw:flex tw:gap-3 tw:items-center tw:mt-3 tw:text-left'}>
        <input className={'checkbox'} type={'checkbox'} required />
        <span>
          Ich bin mit den <a href={'/m'}>Mietbedingungen</a> einverstanden.
        </span>
      </label>
      <div
        className={
          'tw:flex tw:max-sm:flex-col-reverse tw:gap-4 tw:items-center tw:justify-center tw:mt-8'
        }>
        <button onClick={onPrev} className={'button'} type={'button'}>
          Zurück
        </button>
        <button className={'button tw:max-w-[400px]'}>
          Weiter zur Zahlungsart
        </button>
      </div>

      <Pflicht />
    </form>
  );
}
